export default "__VITE_ASSET__d55982f1__"